function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "hide-icon");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "WHS---Dashboard",
  transform: "translate(-482.000000, -99.000000)",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M499,99 C500.656854,99 502,100.343146 502,102 L502,116 C502,117.656854 500.656854,119 499,119 L485,119 C483.343146,119 482,117.656854 482,116 L482,102 C482,100.343146 483.343146,99 485,99 L499,99 Z M485,100 C483.895431,100 483,100.895431 483,102 L483,116 C483,117.104569 483.895431,118 485,118 L488,118 L488,100 L485,100 Z M489,118 L499,118 C500.104569,118 501,117.104569 501,116 L501,102 C501,100.895431 500.104569,100 499,100 L489,100 L489,118 Z",
  id: "hide-icon"
})));

var SvgShowIcon = function SvgShowIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    style: {
      display: "block",
      transform: "scale(-1,1)"
    },
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShowIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/show-icon.32cfbec5.svg";
export { ForwardRef as ReactComponent };